import React, { useState } from 'react';
import apiFetch, { defaultApiFetchErrorHandler } from '@scale/frontend-lib/api-fetch';
import { useAsync } from 'react-use-v13';
import { CorpJobStatus } from '@scale/shared/types/corpJobs/CorpJobStatus';
import { HydratedCorpJobJson } from '@scale/shared/types/corpJobs/HydratedCorpJobJson';

interface IFetchCorpJobProgressProps {
  jobId: string;
  intervalMS?: number;
}

export const FetchCorpJobProgress: React.FC<IFetchCorpJobProgressProps> = (
  props: IFetchCorpJobProgressProps,
) => {
  const { jobId, intervalMS } = props;

  const [lastRetrievedDate, setLastRetrievedDate] = useState<Date>();
  const [corpJobData, setCorpJobData] = useState<HydratedCorpJobJson>();

  const finishedStatus = [CorpJobStatus.COMPLETED, CorpJobStatus.ERRORED];
  const cooldownMiliNextCall = intervalMS ?? 5000;

  useAsync(async () => {
    if (corpJobData && finishedStatus.includes(corpJobData.status)) {
      return;
    }

    try {
      const data = await apiFetch<HydratedCorpJobJson>(null, `corp-api/jobs/job/${jobId}`);
      setCorpJobData(data);
      if (corpJobData && finishedStatus.includes(corpJobData.status)) {
        return;
      }

      const timer = setTimeout(async () => {
        setLastRetrievedDate(new Date());
      }, cooldownMiliNextCall);
      return () => clearTimeout(timer);
    } catch (error) {
      defaultApiFetchErrorHandler(error, { handleHttp: true });
      throw error;
    }
  }, [jobId, lastRetrievedDate]);

  return (
    <div>
      Tracking job <b>{jobId}</b> / <b>{corpJobData?.status}</b> <br />
      <b>Progress</b>: {corpJobData?.progress ?? ''} <br />
      <b>Message</b>: {corpJobData?.jsonOutput?.message ?? ''} <br />
    </div>
  );
};
